'use client';

import Image from 'next/image';

/** Dark app surface — must match `globals.css` `.dark` token `--bg: 225 23% 9%`. */
const BOOT_SPLASH_BG = 'hsl(225 23% 9%)';

/**
 * Minimal boot splash shown while TanStack persisted cache restores from IDB.
 * Background is set inline so it works even if `src/lib/**` is not in the Tailwind
 * content scan (utility classes in this file were not generated → transparent → white body).
 */

export function BootSplash() {
  return (
    <div
      className="flex min-h-[100dvh] min-h-screen flex-col items-center justify-center"
      style={{ backgroundColor: BOOT_SPLASH_BG }}
    >
      <Image
        src="/logo.svg"
        alt=""
        width={112}
        height={112}
        className="select-none opacity-95"
        priority
        unoptimized
      />
    </div>
  );
}
